import { render, staticRenderFns } from "./FilesButton.vue?vue&type=template&id=6335f686"
import script from "./FilesButton.vue?vue&type=script&lang=js"
export * from "./FilesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports